import * as HttpService from "../../../../service/HttpService";


/**初始化查询隐患的方法*/
export const findHiddenMicroscope = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/hiddenMicroscope/findHiddenMicroscope", params);
};

/**查询告警的方法 */
export const findalarmResult = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/hiddenMicroscope/findalarmResult", params);
};
/**查询计划外事件的方法 */
export const findOutPlanEvent = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/hiddenMicroscope/findOutPlanEvent", params);
};

/** 查询树的方法 */
export const getTreesInfo = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/getTreesInfo", params);
};




